const mapping: Record<string, string> = {
  id: 'o=>o.Id',
  name: 'o=>o.Name',
}

export const mapSortObjectParam = (key: string) => mapping[key]
